import Dialog from 'ui/organisms/dialogs/Dialog/Dialog';
import Icon from 'ui/atoms/Icon/Icon';
import PropTypes from 'prop-types';
import TextHtml from 'ui/atoms/TextHtml/TextHtml';
import React from 'react';

const DialogPersonalizedProgramExists = ({ t, open = false, courseName, onCancel = () => {}, onSuccess = () => {} }) => {
  return (
    <div>
      <Dialog
        isOpen={open}
        ariaLabel={t('new-course:Personalize')}
        size="l"
        className="dialog-personalize-program"
        onClose={onCancel}
        onCancel={onCancel}
        onSuccess={onSuccess}
        buttonTextSuccess={t('course:Open my version')}
      >
        <div className="personalize-program__wrapper">
          <div className="personalize-program__head">
            <Icon name="pencil" color="primary" size="xl" />
            <h2 className="personalize-program__head-title">{t('new-course:Personalize')}</h2>
          </div>
          <div className="personalize-program__content">
            <div className="personalize-program__subhead">
              <TextHtml text={t('course:You already have a personalized version of x', { name: courseName })} />
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

DialogPersonalizedProgramExists.propTypes = {
  courseName: PropTypes.string,
  onCancel: PropTypes.func,
  onSuccess: PropTypes.func,
  open: PropTypes.bool,
  t: PropTypes.func.isRequired,
};

export default DialogPersonalizedProgramExists;
